export default () => ({
  hillHeight: 0,
  scrollStartPos: 0,
  scrollStopPos: 0,
  posPercent: 0,
  parentHeight: 0,

  scrolled() {
    const scrollPos =
      document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollPos > this.scrollStartPos && scrollPos < this.scrollStopPos) {
      const currPercent =
        (scrollPos - this.scrollStartPos) /
        (this.scrollStopPos - this.scrollStartPos);
      this.posPercent = currPercent;
      if (currPercent > this.posPercent) {
      }
    }
    if (scrollPos > this.scrollStopPos) {
      this.posPercent = 1;
    }
    requestAnimationFrame(() => this.scrolled());
  },

  getVariables() {
    this.scrollStartPos =
      this.$el.getBoundingClientRect().top +
      (document.documentElement.scrollTop || document.body.scrollTop) -
      window.innerHeight;

    this.scrollStopPos = this.scrollStartPos + this.$el.offsetHeight;
    this.parentHeight = this.$el.offsetHeight;
  },

  init() {
    this.getVariables();
    this.scrolled();
    addEventListener('resize', (event) => {
      this.getVariables();
    });
  },
});
